import '@chenfengyuan/datepicker';

const Datepicker = {
  /**
   * Create behaviour for storing the form on the server with AJAX
   * @param {HTMLElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;
    $.fn.datepicker.languages['nl-NL'] = window.LANG.datepicker;

    $(this.node).datepicker({
      language: 'nl-NL',
      format: 'yyyy-mm-dd',
      autoHide: true,
      zIndex: 1100,
    });
  },
};

export default Datepicker;
